import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum, isNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class IndentItemsDto{
    
@ApiProperty()
@IsNotEmpty({message:"indentItem Id  not be empty"})
@IsAlphanumeric()
indentItemId: number;

 @ApiProperty()
 indentMaterialPreparationId: number;

  @ApiProperty()
  itemsubcategoryId: number;

  @ApiProperty()
  itemId: number;

  @ApiProperty()
  quantity: number;

  @ApiProperty()
  receivedQuantity: number;
  
@ApiProperty()
unitId: number;

@ApiProperty()
createdAt: Date;

@ApiProperty()
createdUser: string | null;

@ApiProperty()
updatedAt: Date;

@ApiProperty()
updatedUser: string | null;

@ApiProperty()
versionFlag: number;
@ApiProperty()
isActive: boolean;

}